export const simplifyAnswers = (answerObj: PvWizardResultsQueryVariables) => {
  const { roofDetails, ...answers } = answerObj;
  return {
    ...answers,
    ...(roofDetails?.roofMaterial && {
      roofMaterial: roofDetails?.roofMaterial
    }),
    ...(roofDetails?.roofAge && { roofAge: roofDetails?.roofAge })
  };
};
